<template>
  <div class="launch">
    <h1>This is an launch page</h1>
    <div>code: {{$route.params.code}} </div>
    <div>engine: {{$route.params.engine}} </div>
    <div>shop: {{$route.params.shop}} </div>
  </div>
</template>



<script>
export default {
  created: function () {
    // save jwt token and backend url to vuex
    let payload = {
      code: this.$route.params.code,
      engine:this.$route.params.engine,
      shop:this.$route.params.shop,
    }
    this.$store.commit('initConnection', payload)
    //console.log(payload)

    window.Intercom('update', {
      shopify_domain: payload.shop
    })

    // redirect to home page
    this.$router.push({ path: '/' })
  }
}
</script>
